import { type CSSProperties } from 'typestyle/lib/types';
import DashboardTheme from '../dashboard-theme';

export const grid = (isMobile: boolean): CSSProperties => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
  gap: 16,
});

export const companySelectRow: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginBottom: 16,
};

export const companySelectLabel: CSSProperties = {
  fontSize: 13.5,
  fontWeight: 700,
  color: DashboardTheme.navy800,
};

export const companySelect: CSSProperties = {
  padding: 8,
  paddingLeft: 12,
  paddingRight: 12,
  border: `1px solid ${DashboardTheme.gray200}`,
  borderRadius: 10,
  fontFamily: DashboardTheme.bodyFontFamily,
  fontSize: 13.5,
  color: DashboardTheme.navy800,
  height: 34,
  minWidth: 220,
  backgroundColor: DashboardTheme.white,
};

export const thresholdRow: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  marginBottom: 18,
  flexWrap: 'wrap',
};

export const thresholdInputs: CSSProperties = {
  flex: 1,
  minWidth: 180,
};

export const inputLabel: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  marginBottom: 4,
  color: DashboardTheme.navy800,
  fontFamily: DashboardTheme.bodyFontFamily,
};

export const inputLabelSpaced: CSSProperties = {
  ...inputLabel,
  margin: '12px 0 4px',
};

export const sliderLabels: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 10.5,
  color: DashboardTheme.gray500,
  marginTop: 2,
};

export const sliderValue: CSSProperties = {
  fontFamily: DashboardTheme.monoFontFamily,
  // Without an explicit color this inherits the app shell's default body text color (white),
  // which is invisible against this card's white background.
  color: DashboardTheme.navy800,
  fontWeight: 700,
};

export const description: CSSProperties = {
  fontSize: 12.5,
  color: DashboardTheme.gray700,
  marginTop: 0,
  fontFamily: DashboardTheme.bodyFontFamily,
};

export const previewBox: CSSProperties = {
  border: `1px dashed ${DashboardTheme.gray300}`,
  borderRadius: 10,
  padding: '12px 14px',
  background: DashboardTheme.gray50,
};

export const previewBoxLabel: CSSProperties = {
  fontSize: 10.5,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  color: DashboardTheme.gray500,
  fontWeight: 700,
  marginBottom: 8,
};

export const previewRow: CSSProperties = {
  display: 'flex',
  gap: 8,
  alignItems: 'center',
  background: DashboardTheme.white,
  border: `1px solid ${DashboardTheme.gray200}`,
  borderRadius: 8,
  padding: '10px 12px',
  fontSize: 12,
};

export const previewRowName: CSSProperties = {
  flex: 1,
};

export const previewRoomName: CSSProperties = {
  fontWeight: 600,
  color: DashboardTheme.navy800,
};

export const previewRoomCapacity: CSSProperties = {
  color: DashboardTheme.gray500,
  fontSize: 11,
};

export const previewBadgeWrap: CSSProperties = {
  textAlign: 'center',
};

export const previewBadgeLabel: CSSProperties = {
  fontSize: 10,
  color: DashboardTheme.gray500,
};

export const previewBadgeValue: CSSProperties = {
  fontFamily: DashboardTheme.monoFontFamily,
  fontWeight: 700,
  color: DashboardTheme.navy800,
  background: DashboardTheme.amber100,
  border: `1px solid ${DashboardTheme.amber500}`,
  borderRadius: 6,
  padding: '3px 8px',
  marginTop: 2,
};

export const saveRow = (isMobile: boolean): CSSProperties => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'stretch' : 'center',
  gap: 10,
  marginTop: 18,
});

export const saveButtonWrap: CSSProperties = {
  // PrimaryButton hardcodes its own width to 180px unless `fullWidth` is passed — this wrapper
  // must be at least that wide, or the button visually spills past it into whatever sits next
  // to it in the row.
  width: 200,
  flexShrink: 0,
};

export const validationMessage: CSSProperties = {
  color: DashboardTheme.red500,
  fontSize: 12,
  marginTop: 4,
};
